import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_83: FaireProductEntity = {
  token: "catalog_prod_prod-83",
  type: "product",
  name: "Candle Holder",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 98.96,
  msrpDollars: 247.4,
  sku: "AN0083",
  caseSize: 4,
  material: "Wood",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 160,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
